/**
 * Which deployment am I looking at?
 *
 * `__APP_BRANCH__` is baked in by webpack's DefinePlugin from Amplify's
 * `AWS_BRANCH` build variable (see webpack.config.js). It is `'main'` on the
 * production build, `'testing'` on the testing build, and `'local'` under
 * `npm start`.
 *
 * Everything here is gated on that value rather than living only on the
 * `testing` branch, because the workflow is testing → merge → main (CLAUDE.md).
 * A branch-only commit would either be wiped by the merge or leak into prod;
 * a build-time flag survives the merge and stays inert on `main`.
 */

export const APP_BRANCH: string = typeof __APP_BRANCH__ === 'string' ? __APP_BRANCH__ : 'local'

/** True only for the production (`main`) deployment. */
export const IS_PROD_ENV = APP_BRANCH === 'main'

/** Short badge text for non-prod builds; `null` on prod so callers render nothing. */
export const ENV_LABEL: string | null = IS_PROD_ENV
  ? null
  : APP_BRANCH === 'testing'
    ? 'TESTING'
    : APP_BRANCH.toUpperCase()

/**
 * Stamps `data-env` on <html>. `src/styles.css` hangs the recolored palette off
 * `html[data-env]`, so this one attribute repaints every `penser-*` utility in
 * the app. No-op on prod — the attribute is never set, so the default theme and
 * its specificity are untouched.
 */
export function applyEnvTheme(): void {
  if (IS_PROD_ENV) return
  document.documentElement.dataset.env = APP_BRANCH === 'testing' ? 'testing' : 'local'
}
